import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class isFuture extends Helper {
  @service clock;

  compute([time], { useRealTime = false }) {
    if (useRealTime) {
      return this.clock.realTime < time;
    } else {
      return this.clock.broadcastTime < time;
    }
  }
}
